import {RenderImage} from "../common/expansion/RenderImage";

export class CompaniesAnimationComponent {
    private usingCompanies: HTMLElement[];

    constructor(
        private container: HTMLElement
    ) {
        this.usingCompanies
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-using-company]'));
    }
    public initialize(): void {
        this.container.classList.add('visibility');
        RenderImage.loadImageSettingsCheck(this.container, this.usingCompanies);
    }
}
